import { DataCache, QueryResultsRelationship, ForeignKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { BatchesDashboard } from 'data/models/BatchesDashboard';

export class BatchesDashboardCache extends DataCache {
    BatchesDashboards = PCCollection(BatchesDashboard);

    constructor(data : PCCache) {
        super();

        new ForeignKeyRelationship(data.Organizations, this.BatchesDashboards, null, r => r.Organization, r => r.OrganizationId());
        new QueryResultsRelationship(this.BatchesDashboards, data.RecurringBatches, r => r.Batches);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/batchesdashboard/cache.ts